// TODO: Rename to reviews and combine deleteReview
module.exports = {
  methods: {
    getReview: async function (id) {
      let response = await this.$axios.get(`/v1/reviews/${id}`);
      return response.data;
    },

    likeReview: async function (id) {
      const response = await this.$axios.put(`/v1/review-likes`, {
        reviewId: id,
      });
      return response.data;
    },

    unlikeReview: async function (id) {
      const response = await this.$axios.delete(`/v1/review-likes/${id}`);
      return response.data;
    },
  },
};
